import React, { Component } from 'react'
import { css } from 'aphrodite'
import styles from './styles'
import { connect } from '@cerebral/react'
import { signal, state } from 'cerebral/tags'
import { getDataTransferItems } from './getDataTransferItems'
import canUpload from 'utils/canUpload'

class FileDropZone extends Component {
  constructor(props) {
    super(props)
    this.onDocumentDrop = this.onDocumentDrop.bind(this)
    this.onDocumentDragOver = this.onDocumentDragOver.bind(this)
  }

  onClick(e) {
    const { contextMenu, deselectAllFiles } = this.props
    if (!contextMenu.isVisible) {
      deselectAllFiles()
    }
  }

  onDocumentDragOver(e) {
    const { node, listType, group } = this.props
    const canDrop = listType === 'FOLDER' && node.id && canUpload(group)
    e.preventDefault()
    e.stopPropagation()
    try {
      e.dataTransfer.dropEffect = canDrop ? 'copy' : 'none'
    } catch (err) {
      // continue regardless of error
    }

    return false
  }

  onDocumentDrop(e) {
    e.preventDefault()
    e.stopPropagation()

    const { onFilesDropped, node, showError, listType, group } = this.props
    const canDrop = listType === 'FOLDER' && node.id && canUpload(group)
    if (canDrop) {
      getDataTransferItems(e)
        .then(files => onFilesDropped({ files, node }))
        .catch(e => showError({ key: `media.error.${e.message}` }))
    }

    return false
  }

  render() {
    const { node, children } = this.props
    if (!node) {
      return null
    }

    return (
      <div
        onDrop={this.onDocumentDrop}
        onDragOver={this.onDocumentDragOver}
        className={css(styles.dropZone)}
        onMouseDown={e => this.onClick(e)}
      >
        <div className={css(styles.innerDropZone)}>{children}</div>
      </div>
    )
  }
}

export default connect(
  {
    node: state`node.selectedNode`,
    contextMenu: state`media.contextMenu`,
    deselectAllFiles: signal`media.deselectAllFiles`,
    group: state`app.user.group`,
    listType: state`node.listType`,
    onFilesDropped: signal`media.onFilesDropped`,
    showError: signal`app.showError`
  },
  FileDropZone
)



// WEBPACK FOOTER //
// ./src/components/Media/FileDropZone/fileDropZone.js